// extracted by mini-css-extract-plugin
module.exports = {"header":"CustomerReviews_header___wKiU","summary":"CustomerReviews_summary__H6lI4","root":"CustomerReviews_root__Ec3iJ"};